import { EventAPI } from '../../../api/datamanager/EventAPI';

export class EventsCommand {
    getAll(provider, successCallback, errorCallback) {
        const apiResult = EventAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Eventos");
            }
        });
    }

    save(event, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === event.id) {
            apiResult = EventAPI.create(event.type, event);
            successMessage = "Evento criado com sucesso";
        }
        else {
            apiResult = EventAPI.update(event.type, event.id, event);
            successMessage = "Evento editado com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    associateToCalendar(event, successCallback, errorCallback) {
        const data = {
            dayTypeId: event.dayType.id, 
            calendarId: event.calendar.id, 
            beginDate: event.beginDate, 
            endDate: event.endDate
        }

        const apiResult = EventAPI.associateToCalendar(event.id, data);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Evento associado com sucesso ao Calendário");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    stopOnCalendar(event, successCallback, errorCallback) {
        const data = {
            calendarId: event.calendar.id, 
            beginDate: event.beginDate, 
            endDate: event.endDate
        }

        const apiResult = EventAPI.stopOnCalendar(event.id, data);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Evento interrompido com sucesso no Calendário");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(eventId, successCallback, errorCallback) {
        const apiResult = EventAPI.delete(eventId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Evento eliminado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
